/* istanbul ignore next */
import colors from 'app/assets/styles/colors';
import { ThemeOptions } from '@mui/material';
import { createTheme, Theme } from '@mui/material/styles';
import fonts from 'app/assets/styles/fonts';
import { Theme as EmotionTheme } from '@emotion/react';

declare module '@mui/material/styles' {
  interface Palette {
    asseticPrimary: Palette['primary'];
    border: string;
  }
  interface PaletteOptions {
    asseticPrimary: PaletteOptions['primary'];
    border: string;
  }
}
export interface AsseticTheme extends Theme, EmotionTheme {}

export const MuiFabExtended = {
  minWidth: 100,
  '&$sizeSmall': {
    minWidth: 124,
    padding: '0 16px',
  },
  boxShadow: 'none',
};

export const MuiFabSizeSmall = {
  minWidth: 100,
  padding: '0 16px',
};

const MuiThemeOps: ThemeOptions = {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          a: { color: colors.primary },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          border: `1px solid ${colors.primary}`,
          backgroundColor: colors.white,
          color: colors.primary,
          '&:hover': {
            backgroundColor: colors.sterlingGrey,
          },
          padding: '0 16px',
        },

        extended: MuiFabExtended,
        sizeSmall: MuiFabSizeSmall,
        primary: {
          backgroundColor: colors.secondary,
          color: colors.arcaneNavy,
          '&:hover': {
            backgroundColor: colors.rioGrande,
          },
          border: 'none',
        },
        secondary: {
          backgroundColor: colors.arcticBlue,
          color: colors.arcaneNavy,
          '&:hover': {
            backgroundColor: colors.columbiaBlue,
          },
          border: 'none',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: { primary: colors.primary },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          paddingTop: 4,
          fontSize: fonts.default,
        },
        contained: {
          marginLeft: 0,
        },
      },
    },
  },
};
/**
 * https://material-ui.com/customization/palette/#dark-mode
 * From material-ui, it will only update certain objects when switching type between 'dark' and 'light',
 * in order to have a custom color in different theme, we can export a darkTheme with same object keys
 */
// export const darkTheme = createMuiTheme({});

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.dudeNavy,
      contrastText: colors.white,
      light: colors.bluePastel,
    },
    secondary: {
      main: colors.secondary,
      contrastText: colors.arcaneNavy,
    },
    asseticPrimary: { main: colors.primary },
    background: { default: colors.white },
    border: colors.chromiumGray,
  },
  components: MuiThemeOps.components,
}) as AsseticTheme;
